import {Routes, Route} from 'react-router-dom'
import {useEffect} from 'react'
import './global.css'
import {Home} from "./components/Home/Home";
import {Landing} from "./components/Landing/Landing";
import {useAuthContext} from "./contexts/AuthContext";
import {Year} from "./components/Year/Year";
import {CompanyInfo} from "./components/CompanyInfo/CompanyInfo";
import {AppProvider} from "./contexts/AppContext";
import {AuthProvider} from "./contexts/AuthContext";
import {NavProvider} from "./contexts/NavContext";
import {ConfirmProvider} from "./contexts/ConfirmContext";
import {ThemeProvider} from "./contexts/ThemeContext";
import {QuestionsProvider} from "./contexts/QuestionsContext";
import {ApprovalsProvider} from "./contexts/ApprovalsContext";
import {Login} from "./components/Login/Login";
import {RouteGuard} from "./components/common/RouteGuard";
import {AppLayout} from "./components/common/AppLayout/AppLayout";
import {IdleLogout} from "./components/common/IdleLogout/IdleLogout";
import TermsOfServicePage from "./pages/legal/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/legal/PrivacyPolicyPage";
import DPAPage from "./pages/legal/DPAPage";
import {DataUpload} from "./components/DataUpload/DataUpload";
import {UploadHelp} from "./components/DataUpload/UploadHelp/UploadHelp";
import {Help} from "./components/Help/Help";
import {AdminRouteGuard} from "./components/Admin/AdminRouteGuard";
import {AdminLayout} from "./components/Admin/AdminLayout";
import {AdminDashboard} from "./components/Admin/Dashboard/AdminDashboard";
import {AdminUsers} from "./components/Admin/Users/AdminUsers";
import {AdminData} from "./components/Admin/Data/AdminData";
import {AdminNomenclature} from "./components/Admin/Nomenclature/AdminNomenclature";
import {AdminActivity} from "./components/Admin/Activity/AdminActivity";
import {AdminSystem} from "./components/Admin/System/AdminSystem";
import {AdminLinks} from "./components/Admin/Links/AdminLinks";
import {AdminQuestions} from "./components/Admin/Questions/AdminQuestions";
import {PublicView} from "./components/Public/PublicView";


// Д3: „/" показва публичната landing за нелогнат потребител, а за логнат —
// началния екран (Home) в общия layout, както досега.
const RootEntry = () => {
    const {isAuthenticated} = useAuthContext();
    return isAuthenticated ? <AppLayout><Home/></AppLayout> : <Landing/>;
};


function App() {

    // Г6: блокиране на десен бутон (възпираща мярка срещу сваляне/копиране).
    useEffect(() => {
        const block = (e) => e.preventDefault();
        document.addEventListener('contextmenu', block);
        return () => document.removeEventListener('contextmenu', block);
    }, []);

    return (
        // ThemeProvider е ПОД AuthProvider — темата зависи от това дали
        // потребителят е вписан (невписан = винаги светло).
        <AuthProvider>
            <ThemeProvider>
            <AppProvider>
                <QuestionsProvider>
                <ApprovalsProvider>
                <NavProvider>
                <ConfirmProvider>
                    {/* Р4: брои бездействието и изкарва предупреждението над
                        всичко останало. Стои извън <Routes>, за да не се
                        занулява часовникът при всяка смяна на страница. */}
                    <IdleLogout/>
                    <div className="container">
                        <Routes>
                            {/*<Route path="/home" element={<Home/>}/>*/}
                            <Route path="/login" element={<Login/>}/>
                            {/* Правни страници (публични, извън RouteGuard). Старите
                                /terms и /policy остават като псевдоними за съвместимост. */}
                            <Route path="/terms-of-service" element={<TermsOfServicePage/>}/>
                            <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}/>
                            <Route path="/dpa" element={<DPAPage/>}/>
                            <Route path="/terms" element={<TermsOfServicePage/>}/>
                            <Route path="/policy" element={<PrivacyPolicyPage/>}/>
                            {/* Е10: публична страница по токен — извън RouteGuard И извън AppLayout. */}
                            <Route path="/p/:token" element={<PublicView/>}/>
                            <Route path="/" element={<RootEntry/>}/>
                            <Route element={<RouteGuard/>}>
                                <Route element={<AppLayout/>}>
                                    <Route path="/:year/*" element={<Year/>}/>
                                    <Route path="/info/:year/:settlement_ekatte/:bullstat/*" element={<CompanyInfo/>}/>
                                    <Route path="/data-upload" element={<DataUpload/>}/>
                                    <Route path="/upload-help" element={<UploadHelp/>}/>
                                    <Route path="/help" element={<Help />}/>
                                    {/* Д1: админ панел — под AppLayout (Ред 1 остава), само за админ */}
                                    <Route path="/admin" element={<AdminRouteGuard><AdminLayout/></AdminRouteGuard>}>
                                        <Route index element={<AdminDashboard/>}/>
                                        <Route path="questions" element={<AdminQuestions/>}/>
                                        <Route path="users" element={<AdminUsers/>}/>
                                        <Route path="data" element={<AdminData/>}/>
                                        <Route path="nomenclature" element={<AdminNomenclature/>}/>
                                        <Route path="links" element={<AdminLinks/>}/>
                                        <Route path="activity" element={<AdminActivity/>}/>
                                        <Route path="system" element={<AdminSystem/>}/>
                                    </Route>
                                </Route>
                            </Route>
                        </Routes>
                    </div>
                </ConfirmProvider>
                </NavProvider>
                </ApprovalsProvider>
                </QuestionsProvider>
            </AppProvider>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;
